import { exportFilterDTO, filterDTO, submitFilterDTO } from "../../types";
import { isFilterUserTypedValueEmptyArray } from "../../UtilFunctions";
import { convertDateToIso, isIsoDate } from "./../FilterFormFunctions";



function DataConvertionUiToApi(type: string, value: any) {
    let newValue: any[] = [];

    if (type == "textbox" || type == "MultiSelectBox") {
        value.map((val: any) => {
            if (typeof val === 'object' && val.id !== undefined) {
                newValue.push(val.id)
            }
        })
    } else if (type == "datepicker") {
        value.map((val: any) => {
            if (!isIsoDate(val)) {
                newValue.push(convertDateToIso(val))
            } else {
                newValue.push(val)
            }
        })
    } else if (type == "boolean") {
        value.map((val: any) => {
            if (val == 1) {
                newValue.push("true")
            } else if (val == 0) {
                newValue.push("false")
            }
        })
    } else {
        newValue.push("Undefined typeUI")
    }

    if (newValue.length > 0) {
        return newValue
    } else {
        return value;
    }
}


const MapperFilterDTOtoExportFilterDTO = (filterData: filterDTO[]): exportFilterDTO[] => {
    let tmpExportedData: exportFilterDTO[] = [];
    //let tmpActiveFilters: filterDTO [] = [];
    //let isEmpty: boolean;

      filterData.filter((filter: filterDTO) => {
        if (filter.userValues != null && filter.userValues != undefined) {
            /*isEmpty = true;
            filter.userValues.map((value: string) => {
                if (value != "") {
                    isEmpty = false;
                }
            })*/
            //isFilterUserValueEmptyArray(filter)
            //if (!isEmpty) {
            if (!isFilterUserTypedValueEmptyArray(filter)) {
                tmpExportedData.push({
                    columnName: filter.columnName,
                    operatorID: filter.operatorID,
                    operatorDataTypeID: filter.operatorDataTypeID,
                    values: filter.userValues.length > 0 ? DataConvertionUiToApi(filter.typeUI, filter.userValues) : {}
                })
                //tmpActiveFilters?.push(filter);
            }
        }
      })
    
    return tmpExportedData;
}

export default MapperFilterDTOtoExportFilterDTO